import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import {
  Alert, Box, Button, Dialog, DialogContent, DialogTitle,
  CardActions, Checkbox, IconButton, Modal, Paper, Snackbar, Stack, Tab, Table, TableBody, TableContainer, TableRow, Tabs, TextField,
} from "@mui/material";
import Historico from "../Historico/historico";
import { IParcela } from "../../Interfaces/beneficiarios/beneficiario";
import { StyledTableHeadWithoutBorder, StyledTableCellWithoutBorder } from "../../Styles/tabelCellStyled/customTableCell";
import SearchIcon from "@mui/icons-material/Search";
import dayjs, { Dayjs } from "dayjs";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { get, get_login, post } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { func_print } from "../../Func_genericas/func_print";
import { cores, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { IBeneficiarios } from "../../Interfaces/beneficiarios/beneficiario";
import { ICaderno } from "../../Interfaces/cadernos/caderno1";
import { loader } from "../../Func_genericas/loader";
import { BarraDeFerramentas } from "../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { DialogNovoCadernoManual } from "../Home_tecnico/dialog_novo_caderno_manual";
import { DialogReplicarCadernoDeAnoAnterior } from "../Home_tecnico/dialog_replicar_caderno_de_ano_anterior";
import { DialogNovaEficienciaAlimentar } from "../EficAlimentar/1-IdentificbenefExp/dialog_novo_eficiencia_alimentar";
import { isValidEmail } from "../../Func_genericas/isValidEmail";
import DocsUploadIE from "../../Components/Upload/DocsUploadIE";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { display: "flex" },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
  })
);

function HomeAgricultor() {
  const classes = useStyles();
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(true);
  const [agricultor, set_agricultor] = useState<IBeneficiarios | null>(null);
  const [lista_cadernos, set_lista_cadernos] = useState<ICaderno[]>([]);
  const [nome_empresa, set_nome_empresa] = useState<string>("");
  const [hover, setHover] = useState({ flag: false, id: 0 });
  const [openInfoAboutBeneficiario, setOpenInfoAboutBeneficiario] = useState(false);
  const [valueTab, setValueTab] = useState("1");
  const [lista_parcelas, set_lista_parcelas] = useState<IParcela[]>([]);
  const [beneficiarios_upload, set_beneficiarios_upload] = useState<IBeneficiarios[]>([]);
  const [beneficiarios_upload_pesquisa, set_beneficiarios_upload_pesquisa] = useState<IBeneficiarios[]>([]);
  const [lista_parcelas_a_eliminar, set_lista_parcelas_a_eliminar] = useState<IParcela[]>([]);
  const [uploadIE_from_parcelas, setuploadIE_from_parcelas] = useState(false);
  const [open_modal_criar_parcela, set_open_modal_criar_parcela] = useState(false);
  const [open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas, set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas] = useState(false);
  const [flag_eliminar_varias_parcelas, set_flag_eliminar_varias_parcelas] = useState(false);
  const [flag_nova_parcela, set_flag_nova_parcela] = useState(false);
  const [n_parcelario, set_n_parcelario] = useState("");
  const [n_sequencia, set_n_sequencia] = useState("");
  const [nome_parcela, set_nome_parcela] = useState("");
  const [area_parcela, set_area_parcela] = useState("");
  const [iqfp, set_iqfp] = useState("");
  const [error_iqfp, set_error_iqfp] = useState(false);
  const [message_iqfp, set_message_iqfp] = useState("");
  const [error_n_parcela, set_error_n_parcela] = useState(false);
  const [error_n_sequencia, set_error_n_sequencia] = useState(false);
  const [error_area, set_error_area] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [benefForm, setBenefForm] = useState({
    nome: "",
    nif: "",
    nifap: "",
    email: "",
    telefone: "",
    telemovel: "",
    morada: "",
    Codigo_postal: "",
    freguesia: "",
    Concelho: "",
  });

  // criar caderno
  const [flag_gerir_caderno, setflag_gerir_caderno] = useState(false);
  const [flag_escolha_caderno_manual, setflag_escolha_caderno_manual] = useState(false);
  const [flag_escolha_carregar_candidatura, setflag_escolha_carregar_candidatura] = useState(false);
  const [flag_criar_caderno_de_ano_anterior, set_flag_criar_caderno_de_ano_anterior] = useState(false);
  const [valueYear, setValueYear] = useState<Dayjs | null>(dayjs());
  const [drapChoose, setDrapChoose] = useState("");
  const [cultura, set_cultura] = useState("");
  const [cor, set_cor] = useState("#c94f1e");
  const [ set_obj_template_escolhido] = useState<any>(null);

  // eficiência alimentar
  const [flag_gerir_eficiencia, setflag_gerir_eficiencia] = useState(false);
  const [id_agri_eficiencia, set_id_agri_eficiencia] = useState(0);

  const [openSnackError, setOpenSnackError] = useState(false);
  const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
  const [message, setMessage] = useState("");

  const idExterno =
    auth.id_agricultor_externo ?? (auth.user as { id_agricultor_externo?: number } | null)?.id_agricultor_externo;

  const normalizePhone = (value: string) => {
    const digits = value.replace(/\D/g, "");
    if (!digits) {
      return "";
    }
    return parseInt(digits.slice(-9), 10);
  };

  const syncBenefForm = (benef: IBeneficiarios) => {
    setBenefForm({
      nome: benef.nome ?? "",
      nif: String(benef.nif ?? ""),
      nifap: String(benef.nifap ?? ""),
      email: benef.email ?? "",
      telefone: benef.telefone != null ? String(benef.telefone) : "",
      telemovel: benef.telemovel != null ? String(benef.telemovel) : "",
      morada: benef.morada ?? "",
      Codigo_postal: benef.Codigo_postal ?? "",
      freguesia: benef.freguesia ?? "",
      Concelho: benef.Concelho ?? "",
    });
    setErrorEmail(false);
  };

  const handleUpdateBeneficiario = async () => {
    if (!agricultor) {
      return;
    }
    if (benefForm.email && !isValidEmail(benefForm.email)) {
      setErrorEmail(true);
      setMessage("Email inválido.");
      setOpenSnackError(true);
      return;
    }
    try {
      setIsLoading(true);
      const response = await post(auth.token.cookie_token, `/update_beneficiario`, {
        payload: {
          id_agri: agricultor.id_agri,
          nome: benefForm.nome,
          email: benefForm.email,
          telefone: normalizePhone(benefForm.telefone),
          telemovel: normalizePhone(benefForm.telemovel),
          morada: benefForm.morada,
          Concelho: benefForm.Concelho,
          freguesia: benefForm.freguesia,
          Codigo_postal: benefForm.Codigo_postal,
          nif: benefForm.nif,
          nifap: benefForm.nifap,
          disabled: agricultor.disabled,
          last_update: new Date().toISOString(),
          create_date: agricultor.create_date ?? new Date().toISOString(),
          id_org: agricultor.id_org,
          uuid: agricultor.uuid ?? "",
        },
      });
      if (response.status === 200) {
        const updatedBenef = response.data.result as IBeneficiarios;
        set_agricultor(updatedBenef);
        syncBenefForm(updatedBenef);
        setMessage(operacao_sucesso);
        setOpenSnackSuccess(true);
      } else {
        setMessage(operacao_erro);
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdateBeneficiario HomeAgricultor", error, true);
      setMessage(operacao_erro);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const message_apenas_numeros_0e5 = "Apenas números entre 0 e 5 são permitidos.";

  const func_clean_parcela = () => {
    set_nome_parcela("");
    set_n_sequencia("");
    set_area_parcela("");
    set_n_parcelario("");
    set_iqfp("");
    set_error_n_parcela(false);
    set_error_n_sequencia(false);
    set_error_area(false);
    set_error_iqfp(false);
    set_message_iqfp("");
    set_flag_nova_parcela(false);
  };

  const handle_registar_nova_parcela = async () => {
    if (!agricultor) {
      return;
    }
    try {
      if (!error_n_parcela && !error_n_sequencia && !error_area && !error_iqfp) {
        setIsLoading(true);
        const data = await post(auth.token.cookie_token, `/new_parcela`, {
          payload: {
            nome: nome_parcela,
            primeiro_pilar: "",
            uuid: "",
            seccao_finan: "",
            segundo_pilar: "",
            artigo: "",
            iqfp: iqfp,
            forma: "",
            acao: "",
            s_n_l: "",
            Data_ultima_atualizacao: new Date().toISOString(),
            id_parcela: 0,
            multiDec: "",
            id_agri: agricultor.id_agri,
            numero_seq: n_sequencia,
            area_gis: area_parcela,
            numero_Parce: n_parcelario,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
          },
        });
        if (data.status === 200) {
          set_lista_parcelas((old) => [...old, data.data.result]);
          setMessage(operacao_sucesso);
          setOpenSnackSuccess(true);
          set_open_modal_criar_parcela(false);
          func_clean_parcela();
        } else {
          setMessage(operacao_erro);
          setOpenSnackError(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      func_print("handle_registar_nova_parcela HomeAgricultor", error, true);
      setMessage(operacao_erro);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handle_delete_parcelas_selecionadas = async () => {
    try {
      setIsLoading(true);
      const res = await post(auth.token.cookie_token, `delete_multiplas_parcela`, {
        ids: lista_parcelas_a_eliminar.map((el) => el.id_parcela),
      });
      if (res.status === 200) {
        const lista_aux = lista_parcelas.filter((el) => !lista_parcelas_a_eliminar.some((s) => s.id_parcela === el.id_parcela));
        set_lista_parcelas(lista_aux);
        setMessage("Registos eliminados com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(false);
        set_flag_eliminar_varias_parcelas(false);
        set_lista_parcelas_a_eliminar([]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar registos!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_parcelas_selecionadas HomeAgricultor", error, true);
      setMessage("Erro ao eliminar registos!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const cadernoAtivo = (caderno: ICaderno) => {
    auth.func_setId_rosto_from_caderno(caderno.id_rosto);
    auth.func_setNif_agricultor_from_caderno(String(caderno.nif));
    auth.func_setNome_agricultor_from_caderno(caderno.nome);
    auth.func_set_id_agricultor_para_eficiencia_alimentar(caderno.id_agri);
    auth.func_set_cor(caderno.cor);
    auth.func_set_cultura(caderno.cultura_caderno);
    navigate("/IdentificacaoBenExp", { state: caderno });
  };

  const handle_gerir_caderno = async (id_rosto: number) => {
    try {
      const res = await get(auth.token.cookie_token, `/get_rosto_valida/${id_rosto}`);
      if (res.status === 200) {
        cadernoAtivo(res.data.result);
      } else {
        setMessage(operacao_erro);
        setOpenSnackError(true);
      }
    } catch (error) {
      func_print("handle_gerir_caderno agr", error, true);
      setMessage(operacao_erro);
      setOpenSnackError(true);
    }
  };

  const getParcelas = async (id_agri_arg: number | undefined) => {
    try {
      setIsLoading(true);
      const response = await get(auth.token.cookie_token, `/get_parcela_agri/${id_agri_arg}`);
      if (response.status === 200) {
        set_lista_parcelas(response.data.result);
      } else {
        setMessage(operacao_erro);
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getParcelas HomeAgricultor", error, true);
      setMessage(operacao_erro);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handleChangeTabNavigation = async (_: React.SyntheticEvent, newValue: string) => {
    if (newValue === "3") {
      await getParcelas(agricultor?.id_agri);
    }
    setValueTab(newValue);
  };

  const handleCreateCaderno = async () => {
    try {
      setIsLoading(true);
      const response = await post(auth.token.cookie_token, `/gerarCaderno`, {
        payload: {
          ano: valueYear?.format("YYYY"),
          id_agri: agricultor?.id_agri,
          drap: drapChoose,
          cultura_caderno: cultura,
          cor: cor,
        },
      });
      if (response.status === 200) {
        cadernoAtivo(response.data.result);
        auth.func_setId_rosto_from_caderno(response.data.result.id_rosto);
        auth.func_setNif_agricultor_from_caderno(response.data.result.nif);
        auth.func_setNome_agricultor_from_caderno(response.data.result.nome);
        auth.func_set_id_agricultor_para_eficiencia_alimentar(response.data.result.id_agri);
        auth.func_set_cor(response.data.result.cor);
        auth.func_set_cultura(response.data.result.cultura_caderno);
        setMessage(operacao_sucesso);
        setOpenSnackSuccess(true);
      } else {
        setMessage(operacao_erro);
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      const msg = error?.message?.includes("400")
        ? "Já existe um caderno com o ano selecionado."
        : operacao_erro;
      setMessage(msg);
      func_print("handleCreateCaderno HomeAgricultor", error, true);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const chamar_componente_eficiencia = async (id: number) => {
    const response = await get(auth.token.cookie_token, `/get_Tabela_ano_eficiencia_Idagricultor/${id}`);
    if (response.status === 200) {
      const aux_tabela = response.data.result.map((el: any) => {
        if (el.ano === undefined || el.ano !== valueYear?.format("YYYY").toString()) {
          return response.data.result;
        }
        return el;
      });
      if (aux_tabela.length <= 0) {
        setflag_gerir_eficiencia(true);
        set_id_agri_eficiencia(id);
      } else {
        const res = await get(auth.token.cookie_token, `/get_caderno_eficiencia_id/${aux_tabela[0].id_identificacao}`);
        if (res.status === 200) {
          setflag_gerir_eficiencia(false);
          auth.func_setId_rosto_from_caderno(res.data.result.id_rosto);
          auth.func_setNif_agricultor_from_caderno(res.data.result.nif);
          auth.func_setNome_agricultor_from_caderno(res.data.result.nome);
          auth.func_set_id_agricultor_para_eficiencia_alimentar(res.data.result.id_agri);
          navigate("/EFIdentBenfExp", { state: res.data.result });
        }
      }
    }
  };

  const loadData = async () => {
    if (idExterno == null) {
      setMessage("Sessão inválida: falta identificação do agricultor.");
      setOpenSnackError(true);
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const resAg = await get(auth.token.cookie_token, `/agricultores/${idExterno}`);
      if (resAg.status !== 200) {
        setMessage(operacao_erro);
        setOpenSnackError(true);
        setIsLoading(false);
        return;
      }
      const benef = resAg.data.result as IBeneficiarios;
      set_agricultor(benef);
      syncBenefForm(benef);

      const idOrg = auth.user?.id_org;
      if (idOrg == null) {
        setMessage(operacao_erro);
        setOpenSnackError(true);
        setIsLoading(false);
        return;
      }

      const resOrg = await get_login(auth.token.cookie_token, `/get_organization_by_id/${idOrg}`);
      if (resOrg.status === 200) {
        const org = resOrg.data.result;
        const nome =
          org?.nome ??
          org?.name ??
          org?.designacao ??
          org?.organization_name ??
          "Os meus cadernos";
        set_nome_empresa(String(nome));
      }

      const resCadernos = await get(auth.token.cookie_token, `/get_cadernos_list_ativos/${idOrg}`);
      if (resCadernos.status === 200) {
        const todos: ICaderno[] = resCadernos.data.result ?? [];
        set_lista_cadernos(todos.filter((c) => c.id_agri === benef.id_agri));
      } else {
        setMessage(operacao_erro);
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("loadData HomeAgricultor", error, true);
      setMessage(operacao_erro);
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    void loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idExterno, auth.token.cookie_token, auth.user?.id_org]);

  if (isLoading && !agricultor) {
    return loader();
  }

  return (
    <div className={classes.root}>
      <HomeViewTecnico title={nome_empresa} drawerMode="agricultor" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />

        <Snackbar open={openSnackError} autoHideDuration={4000} onClose={() => setOpenSnackError(false)}>
          <Alert onClose={() => setOpenSnackError(false)} severity="error" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>

        <div className="flex flex-col gap-6 p-2">

          {/* painel de info do agricultor */}
          {agricultor && (
            <div className="flex flex-wrap items-center justify-between gap-4 w-full rounded-xl bg-gray-50/80 p-5">
              {/* left: NIF + email */}
              <div className="flex flex-wrap gap-6">
                <div className="flex flex-col gap-1 min-w-[120px]">
                  <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">NIF</span>
                  <span className="text-base font-medium text-gray-800">{agricultor.nif}</span>
                </div>
                {agricultor.email && (
                  <div className="flex flex-col gap-1 min-w-[180px]">
                    <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">Email</span>
                    <span className="text-base font-medium text-gray-800">{agricultor.email}</span>
                  </div>
                )}
                {agricultor.morada && (
                  <div className="flex flex-col gap-1 min-w-[180px]">
                    <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">Morada</span>
                    <span className="text-base font-medium text-gray-800">{agricultor.morada}</span>
                  </div>
                )}
              </div>

              {/* right: action buttons */}
              <div className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => setOpenInfoAboutBeneficiario((v) => !v)}
                  title={openInfoAboutBeneficiario ? "Fechar painel" : "Visualizar beneficiário"}
                  className={`inline-flex items-center justify-center px-3 py-2.5 rounded-xl transition-all duration-200 border-0 outline-none cursor-pointer ${openInfoAboutBeneficiario ? "text-[#c94f1e] bg-[#f2d1c2]/30 ring-2 ring-[#c94f1e]" : "text-white bg-[#c94f1e] hover:bg-[#b84720]"}`}
                >
                  <SearchIcon sx={{ fontSize: 18 }} />
                </button>
                <button
                  type="button"
                  onClick={() => navigate("/pportalagricultor", { state: agricultor.id_agri })}
                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                >
                  Portal do Agricultor
                </button>
                <button
                  type="button"
                  onClick={() => void chamar_componente_eficiencia(agricultor.id_agri)}
                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                >
                  Eficiência Alimentar
                </button>
                <button
                  type="button"
                  onClick={() => { setflag_gerir_caderno(true); }}
                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                >
                  Criar Caderno
                </button>
              </div>
            </div>
          )}

          {/* content: cadernos (left) + info panel (right when lupa open) */}
          <div style={{ display: "flex", gap: 16 }}>

            {/* cadernos ativos */}
            <div style={{ flex: openInfoAboutBeneficiario ? 0.4 : 1 }}>
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3">
                Cadernos ativos
              </p>

              {lista_cadernos.length === 0 ? (
                <p className="text-sm text-gray-400">Não tem cadernos ativos associados.</p>
              ) : (
                <div className="flex flex-wrap gap-4">
                  {lista_cadernos.map((elem, key) => {
                    const isHovered = hover.flag && hover.id === elem.id_rosto;
                    return (
                      <div
                        key={key}
                        className={`
                          flex flex-col items-center justify-between w-[160px] min-w-[160px] p-4
                          rounded-xl cursor-pointer transition-all duration-200
                          bg-gray-50/80
                          ${isHovered ? "shadow-md" : "shadow-sm"}
                        `}
                        onMouseEnter={() => setHover({ flag: true, id: elem.id_rosto })}
                        onMouseLeave={() => setHover({ flag: false, id: elem.id_rosto })}
                        onClick={() => void handle_gerir_caderno(elem.id_rosto)}
                      >
                        <div className="flex flex-col items-center gap-1 w-full">
                          <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 text-center">
                            {elem.ano}
                          </span>
                          <span className="text-sm font-medium text-gray-800 text-center leading-snug">
                            {elem.cultura_caderno}
                          </span>
                        </div>
                        <div
                          className="mt-3 w-full h-1 rounded-full"
                          style={{ backgroundColor: elem.cor || "#c94f1e" }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* painel histórico / parcelas (igual ao de Home.tsx) */}
            {openInfoAboutBeneficiario && agricultor && (
              <div style={{ flex: 0.6, paddingLeft: 10, height: "75vh", display: "flex" }}>
                <TableContainer component={Paper} variant="outlined" sx={{ height: "auto", width: "100%" }}>
                  <Box sx={{ width: "100%" }}>
                    <Tabs
                      value={valueTab}
                      variant="fullWidth"
                      onChange={handleChangeTabNavigation}
                    >
                      <Tab value="1" label="Visualizar Beneficiário" sx={{ fontWeight: 700, fontFamily: "candara", fontSize: 18 }} />
                      <Tab value="2" label="Histórico" sx={{ fontWeight: 700, fontFamily: "candara", fontSize: 18 }} />
                      <Tab value="3" label="Listagem Parcelas" sx={{ fontWeight: 700, fontFamily: "candara", fontSize: 18 }} />
                    </Tabs>
                  </Box>

                  <TableContainer style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
                    <table width="90%">
                      {valueTab === "1" ? (
                        <TableBody>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Nome</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.nome}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, nome: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>NIF</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.nif}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, nif: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>NIFAP</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.nifap}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, nifap: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Email</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.email}
                                error={errorEmail}
                                helperText={errorEmail ? "Email inválido." : ""}
                                onChange={(e) => {
                                  setErrorEmail(false);
                                  setBenefForm((prev) => ({ ...prev, email: e.target.value }));
                                }}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Telefone</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.telefone}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, telefone: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Telemóvel</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.telemovel}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, telemovel: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Morada</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.morada}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, morada: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Código Postal</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.Codigo_postal}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, Codigo_postal: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Freguesia</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.freguesia}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, freguesia: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableHeadWithoutBorder>Concelho</StyledTableHeadWithoutBorder>
                            <StyledTableCellWithoutBorder>
                              <TextField
                                fullWidth
                                size="small"
                                value={benefForm.Concelho}
                                onChange={(e) => setBenefForm((prev) => ({ ...prev, Concelho: e.target.value }))}
                              />
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                          <TableRow>
                            <StyledTableCellWithoutBorder colSpan={2} sx={{ paddingTop: 2 }}>
                              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                  variant="contained"
                                  sx={{ backgroundColor: "#c94f1e", "&:hover": { backgroundColor: "#b84720" } }}
                                  onClick={() => void handleUpdateBeneficiario()}
                                >
                                  Gravar alterações
                                </Button>
                              </Box>
                            </StyledTableCellWithoutBorder>
                          </TableRow>
                        </TableBody>
                      ) : valueTab === "2" ? (
                        <Historico
                          idagri={agricultor.id_agri}
                          idrosto={undefined}
                          nome={agricultor.nome}
                          nif={agricultor.nif}
                        />
                      ) : (
                        <TableBody>
                          <TableRow>
                            <StyledTableHeadWithoutBorder colSpan={5}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                }}
                              >
                                <BarraDeFerramentas
                                  mostrarBotaoNovo
                                  textoBotaoNovo="Adicionar Parcela"
                                  aoClicarNovo={() => {
                                    set_flag_nova_parcela(true);
                                    set_open_modal_criar_parcela(true);
                                  }}
                                />
                                <div style={{ paddingLeft: "2%" }}>
                                  <BarraDeFerramentas
                                    mostrarBotaoUpload
                                    textoBotaoUpload="Upload Ficheiro IE"
                                    aoClicarUpload={() => setuploadIE_from_parcelas(true)}
                                  />
                                </div>
                                <div style={{ paddingLeft: "2%" }}>
                                  <BarraDeFerramentas
                                    mostrarBotaoApagarComIcon
                                    textoBotaoApagar={flag_eliminar_varias_parcelas ? "Eliminar Items Selecionados" : "Eliminar Vários"}
                                    aoClicarApagar={() => {
                                      if (flag_eliminar_varias_parcelas) {
                                        set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(true);
                                      } else {
                                        set_flag_eliminar_varias_parcelas(true);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </StyledTableHeadWithoutBorder>
                          </TableRow>
                          <TableRow>
                            {flag_eliminar_varias_parcelas && (
                              <StyledTableHeadWithoutBorder />
                            )}
                            <StyledTableHeadWithoutBorder>Nº Sequência</StyledTableHeadWithoutBorder>
                            <StyledTableHeadWithoutBorder>Nº Parcelário</StyledTableHeadWithoutBorder>
                            <StyledTableHeadWithoutBorder>Nome da Parcela</StyledTableHeadWithoutBorder>
                            <StyledTableHeadWithoutBorder>Área (ha)</StyledTableHeadWithoutBorder>
                            <StyledTableHeadWithoutBorder>IQFP</StyledTableHeadWithoutBorder>
                          </TableRow>
                          {lista_parcelas.map((p, i) => (
                            <TableRow key={i}>
                              {flag_eliminar_varias_parcelas && (
                                <StyledTableCellWithoutBorder>
                                  <Checkbox
                                    checked={lista_parcelas_a_eliminar.some((el) => el.id_parcela === p.id_parcela)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        set_lista_parcelas_a_eliminar((old) => [...old, p]);
                                      } else {
                                        set_lista_parcelas_a_eliminar((old) => old.filter((el) => el.id_parcela !== p.id_parcela));
                                      }
                                    }}
                                  />
                                </StyledTableCellWithoutBorder>
                              )}
                              <StyledTableCellWithoutBorder>{p.numero_seq}</StyledTableCellWithoutBorder>
                              <StyledTableCellWithoutBorder>{p.numero_Parce}</StyledTableCellWithoutBorder>
                              <StyledTableCellWithoutBorder>{p.nome}</StyledTableCellWithoutBorder>
                              <StyledTableCellWithoutBorder>{p.area_gis}</StyledTableCellWithoutBorder>
                              <StyledTableCellWithoutBorder>{p.iqfp}</StyledTableCellWithoutBorder>
                            </TableRow>
                          ))}
                        </TableBody>
                      )}
                    </table>
                  </TableContainer>
                </TableContainer>
              </div>
            )}

          </div>

        </div>

        {/* modal criar caderno */}
        {flag_gerir_caderno && (
          <Modal
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            open={flag_gerir_caderno}
          >
            <div style={{
              display: "flex", flexDirection: "column", alignItems: "flex-start",
              backgroundColor: "white", width: "40%", height: "80%", borderRadius: 5,
            }}>
              <div style={{ marginLeft: "auto" }}>
                <BarraDeFerramentas
                  mostrarBotaoCancelar
                  aoClicarCancelar={() => {
                    setflag_gerir_caderno(false);
                    setflag_escolha_caderno_manual(false);
                    setflag_escolha_carregar_candidatura(false);
                    set_flag_criar_caderno_de_ano_anterior(false);
                  }}
                />
              </div>
              <div style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                justifyContent: "center", alignSelf: "center", height: "100%", width: "100%",
              }}>
                <div style={{ fontSize: 25, fontWeight: "bold", fontFamily: "candara", marginBottom: 20 }}>
                  Criação de Caderno
                </div>

                {!flag_escolha_caderno_manual && !flag_escolha_carregar_candidatura && !flag_criar_caderno_de_ano_anterior ? (
                  <Stack spacing={3} alignItems="center">
                    <Button
                      size="large"
                      sx={{ width: 250, backgroundColor: cores.cor1, color: "#fff", fontFamily: "candara", "&:hover": { backgroundColor: "transparent", color: "#7e2706" } }}
                      onClick={() => setflag_escolha_caderno_manual(true)}
                    >
                      Criar Caderno Manualmente
                    </Button>
                    <Button
                      size="large"
                      sx={{ width: 250, backgroundColor: "#c94f1e", color: "#fff", fontFamily: "candara", "&:hover": { backgroundColor: "transparent", color: "#7e2706" } }}
                      onClick={() => set_flag_criar_caderno_de_ano_anterior(true)}
                    >
                      Replicar Caderno de Ano Anterior
                    </Button>
                  </Stack>
                ) : flag_escolha_caderno_manual ? (
                  <DialogNovoCadernoManual
                    handleCreateCaderno_arg={() => void handleCreateCaderno()}
                    setDrapChoose_arg={(v: string) => setDrapChoose(v)}
                    setValueYear_arg={(v: Dayjs | null) => setValueYear(v)}
                    set_obj_template_escolhido_arg={(v: any) => set_obj_template_escolhido(v)}
                    set_cor_aux={set_cor}
                    set_cultura_aux={set_cultura}
                  />
                ) : flag_criar_caderno_de_ano_anterior ? (
                  <DialogReplicarCadernoDeAnoAnterior
                    handle_replicar_caderno_de_ano_anterior={() => {}}
                    set_ano_novo_caderno={(v: Dayjs | null) => setValueYear(v)}
                    set_id_caderno_a_replicar={() => {}}
                    set_id_rosto_a_replicar={() => {}}
                    id_agri={agricultor?.id_agri}
                    setIsLoading={(v: boolean) => setIsLoading(v)}
                  />
                ) : null}
              </div>
            </div>
          </Modal>
        )}

        {/* dialog eficiência alimentar */}
        {flag_gerir_eficiencia && (
          <Dialog
            open={flag_gerir_eficiencia}
            onClose={() => setflag_gerir_eficiencia(false)}
            maxWidth="lg"
            sx={{ padding: 10 }}
          >
            <div style={{ marginLeft: "auto" }}>
              <BarraDeFerramentas
                mostrarBotaoCancelar
                aoClicarCancelar={() => setflag_gerir_eficiencia(false)}
              />
            </div>
            <DialogTitle fontFamily="candara" fontSize={22} fontWeight={500}>
              Criação de Eficiência alimentar
            </DialogTitle>
            <DialogContent>
              <DialogNovaEficienciaAlimentar
                id_agri={id_agri_eficiencia}
                setflag_gerir_eficiencia={setflag_gerir_eficiencia}
                setIsLoading={setIsLoading}
              />
            </DialogContent>
          </Dialog>
        )}

        <Dialog
          open={uploadIE_from_parcelas}
          onClose={() => setuploadIE_from_parcelas(false)}
        >
          <Stack direction="column" sx={{ padding: 5 }}>
            <div style={{ display: "flex", paddingBottom: 30 }}>
              <div style={{ display: "flex", flex: 0.9 }}>
                <DialogTitle sx={{ fontFamily: "candara" }}>
                  Importar Ficheiro IE
                </DialogTitle>
              </div>
              <div style={{ display: "flex", flex: 0.1 }}>
                <Button color="inherit" size="small" onClick={() => setuploadIE_from_parcelas(false)}>
                  <CloseIcon />
                </Button>
              </div>
            </div>
            <DocsUploadIE
              onCloseDialog={setuploadIE_from_parcelas}
              set_beneficiario_pesquisa={set_beneficiarios_upload_pesquisa}
              set_beneficiario={set_beneficiarios_upload}
              beneficiario={beneficiarios_upload}
              beneficiario_pesquisa={beneficiarios_upload_pesquisa}
            />
          </Stack>
        </Dialog>

        <Dialog
          open={open_modal_criar_parcela}
          onClose={() => {
            set_open_modal_criar_parcela(false);
            func_clean_parcela();
          }}
          fullWidth
          maxWidth="md"
        >
          <Stack direction="row">
            <DialogTitle sx={{ fontFamily: "candara" }}>
              Registar nova Parcela
            </DialogTitle>
            <div style={{ marginLeft: "auto", marginRight: 0 }}>
              <IconButton
                color="info"
                size="small"
                onClick={() => {
                  set_open_modal_criar_parcela(false);
                  func_clean_parcela();
                }}
              >
                <CloseIcon color="action" />
              </IconButton>
            </div>
          </Stack>
          <div id="novaparcela">
            <DialogContent>
              <Table>
                <TextField
                  fullWidth
                  label="Nº Parcelário"
                  placeholder="Nº Parcelário"
                  required
                  margin="normal"
                  sx={{ width: "50%", paddingRight: "5px" }}
                  value={n_parcelario}
                  onChange={(e) => {
                    const value = e.target.value;
                    set_n_parcelario(value);
                    set_error_n_parcela(!/^[0-9,.]*$/.test(value));
                  }}
                  error={error_n_parcela}
                  helperText={error_n_parcela ? "Inválido" : ""}
                />
                <TextField
                  fullWidth
                  label="Nº Sequência"
                  placeholder="Nº Sequência"
                  required
                  margin="normal"
                  sx={{ width: "50%", paddingRight: "5px" }}
                  value={n_sequencia}
                  onChange={(e) => {
                    const value = e.target.value;
                    set_n_sequencia(value);
                    set_error_n_sequencia(!/^[0-9,.]*$/.test(value));
                  }}
                  error={error_n_sequencia}
                  helperText={error_n_sequencia ? "Inválido" : ""}
                />
                <TextField
                  fullWidth
                  label="Nome da Parcela"
                  placeholder="Nome da Parcela"
                  required
                  margin="normal"
                  sx={{ width: "100%", paddingRight: "5px" }}
                  value={nome_parcela}
                  onChange={(e) => set_nome_parcela(e.target.value)}
                />
                <TextField
                  fullWidth
                  label="Área (ha)"
                  required
                  placeholder="Área (ha)"
                  margin="normal"
                  sx={{ width: "50%", paddingRight: "5px" }}
                  value={area_parcela}
                  onChange={(e) => {
                    const value = e.target.value;
                    set_area_parcela(value);
                    set_error_area(!/^[0-9,.]*$/.test(value));
                  }}
                  error={error_area}
                  helperText={error_area ? "Inválido" : ""}
                />
                <TextField
                  error={error_iqfp}
                  helperText={error_iqfp ? message_iqfp : ""}
                  fullWidth
                  id="IQFP"
                  label="IQFP"
                  placeholder="IQFP"
                  margin="normal"
                  sx={{ width: "50%", paddingRight: "5px" }}
                  value={iqfp}
                  onChange={(e) => {
                    const value = e.target.value;
                    set_iqfp(value);
                    if (!/^[0-5]$/.test(value.trim())) {
                      set_error_iqfp(true);
                      set_message_iqfp(message_apenas_numeros_0e5);
                    }
                    if (!/^[0-9]*$/.test(value.trim())) {
                      set_error_iqfp(true);
                      set_message_iqfp("Apenas números são permitidos.");
                    }
                    const intValue = parseInt(value, 10);
                    if ((isNaN(intValue) || intValue < 0 || intValue > 5) || value.trim().length > 1) {
                      set_error_iqfp(true);
                      set_message_iqfp("Introduza um número entre 0 a 5.");
                    } else {
                      set_error_iqfp(false);
                      set_message_iqfp("");
                    }
                  }}
                />
              </Table>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                <CardActions>
                  <BarraDeFerramentas
                    mostrarBotaoGravar
                    aoClicarGravar={() => {
                      if (flag_nova_parcela) {
                        void handle_registar_nova_parcela();
                      }
                    }}
                  />
                </CardActions>
              </div>
            </DialogContent>
          </div>
        </Dialog>

        <ConfirmDialog
          open={open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas}
          onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_parcelas_selecionadas(false)}
          onConfirm={() => void handle_delete_parcelas_selecionadas()}
          message="Deseja eliminar os registos selecionados?"
        />

        <Snackbar open={openSnackSuccess} autoHideDuration={4000} onClose={() => setOpenSnackSuccess(false)}>
          <Alert onClose={() => setOpenSnackSuccess(false)} severity="success" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>
      </main>
    </div>
  );
}

export default HomeAgricultor;
